// Shared labels for the 3-step Import-Anleitung, used by both
// MasterDataImport (in Administration) and OnboardingStepImportUpload.
// The component-specific descriptions (Step 2 detail variants, Step 3 wording per context)
// stay local in each consumer.

export const IMPORT_STEP_TEXTS = {
  downloadNewTemplate: {
    title: 'Vorlage herunterladen',
    description: 'Laden Sie unsere Excel-Vorlage herunter.'
  },
  downloadSyncExport: {
    title: 'Stammdaten herunterladen',
    description: 'Laden Sie Ihre Stammdaten herunter.'
  },
  fillTemplate: {
    title: 'Vorlage ausfüllen'
  }
};
